export const dataDefault = [{
    name: "1000&lt;Conference Area<br/>1000&lt;会议厅面积",
    space1: 0,
    space2: 0,
    space3: 0,
    space4: 0,
    space5: 0,
    space6: 0,
    space7: 0,
    sort: 0,
}, {
    name: "Ballroom A <br/>多功能宴会厅A",
    space1: 0,
    space2: 0,
    space3: 0,
    space4: 0,
    space5: 0,
    space6: 0,
    space7: 0,
    sort: 1,
}, {
    name: "Ballroom B <br/>多功能宴会厅B",
    space1: 0,
    space2: 0,
    space3: 0,
    space4: 0,
    space5: 0,
    space6: 0,
    space7: 0,
    sort: 2,
}, {
    name: "500<=Conference Area<1000 <br/>500<=会议厅面积<1000",
    space1: 0,
    space2: 0,
    space3: 0,
    space4: 0,
    space5: 0,
    space6: 0,
    space7: 0,
    sort: 3,
}, {
    name: "Conference A <br/>大会议室A",
    space1: 0,
    space2: 0,
    space3: 0,
    space4: 0,
    space5: 0,
    space6: 0,
    space7: 0,
    sort: 4,
}, {
    name: "Conference B <br/>大会议室B",
    space1: 0,
    space2: 0,
    space3: 0,
    space4: 0,
    space5: 0,
    space6: 0,
    space7: 0,
    sort: 5,
}, {
    name: "Conference C<br/>大会议室C",
    space1: 0,
    space2: 0,
    space3: 0,
    space4: 0,
    space5: 0,
    space6: 0,
    space7: 0,
    sort: 6,
}, {
    name: "Conference D <br/>大会议室D",
    space1: 0,
    space2: 0,
    space3: 0,
    space4: 0,
    space5: 0,
    space6: 0,
    space7: 0,
    sort: 7,
}, {
    name: "200<=Conference Area<500 <br/>200<=会议厅面积<500",
    space1: 0,
    space2: 0,
    space3: 0,
    space4: 0,
    space5: 0,
    space6: 0,
    space7: 0,
    sort: 8,
}, {
    name: "Conference A<br/>中会议室A",
    space1: 0,
    space2: 0,
    space3: 0,
    space4: 0,
    space5: 0,
    space6: 0,
    space7: 0,
    sort: 9,
}, {
    name: "Conference B<br/>中会议室B",
    space1: 0,
    space2: 0,
    space3: 0,
    space4: 0,
    space5: 0,
    space6: 0,
    space7: 0,
    sort: 10,
}, {
    name: "Conference C <br/>中会议室C",
    space1: 0,
    space2: 0,
    space3: 0,
    space4: 0,
    space5: 0,
    space6: 0,
    space7: 0,
    sort: 11,
}, {
    name: "Conference D <br/>中会议室D",
    space1: 0,
    space2: 0,
    space3: 0,
    space4: 0,
    space5: 0,
    space6: 0,
    space7: 0,
    sort: 12,
}, {
    name: "Conference Area<200 <br/>会议厅面积<200",
    space1: 0,
    space2: 0,
    space3: 0,
    space4: 0,
    space5: 0,
    space6: 0,
    space7: 0,
    sort: 13,
}, {
    name: "Conference A<br/>小会议室A",
    space1: 0,
    space2: 0,
    space3: 0,
    space4: 0,
    space5: 0,
    space6: 0,
    space7: 0,
    sort: 14,
}, {
    name: "Conference B <br/>小会议室B",
    space1: 0,
    space2: 0,
    space3: 0,
    space4: 0,
    space5: 0,
    space6: 0,
    space7: 0,
    sort: 15,
}, {
    name: "Conference C<br/>小会议室C",
    space1: 0,
    space2: 0,
    space3: 0,
    space4: 0,
    space5: 0,
    space6: 0,
    space7: 0,
    sort: 16,
}, {
    name: "Conference D<br/>小会议室D",
    space1: 0,
    space2: 0,
    space3: 0,
    space4: 0,
    space5: 0,
    space6: 0,
    space7: 0,
    sort: 17,
}]

export const intervalData = {
    1: "一亿以上",
    2: "8000万-1亿",
    3: "6500万-8000万",
    4: "5500万-6500万",
    5: "4500万-5500万",
    6: "3500万-4500万",
    7: "2500万-3500万",
    8: "1000万-2500万",
    9: "小于1000万",
}; 


// WEBPACK FOOTER //
// ./src/components/table/effect/1.2/data.js